import type { OMSConfig, StrategyEvaluator, SignalResult, StrategyContext } from '../types';
import * as CONFIG from '../../../config/constants';
import { extractSpotPrice, extractSnapshotOptions } from '../../../lib/snapshot-search';
import { ensureFlatOpts } from '../../analysis/trend-evaluator';
import { getConnectingDotsRows, getSortKey } from './shared';

export const evaluateMinMaxItmTop5: StrategyEvaluator = (marketData: any, currentUnixTime: number, config: OMSConfig, context: StrategyContext): SignalResult | null => {
    if (!marketData) return null;

    const { symbol, expiry, activeRange, gap, settingsMode } = context;
    const spot = extractSpotPrice(marketData) || 0;
    if (spot <= 0) return null;
    
    const atmStrike = Math.round(spot / gap) * gap;

    const { itmRows } = getConnectingDotsRows(marketData, symbol, expiry, atmStrike, activeRange, gap);
    itmRows.sort((a: any, b: any) => getSortKey(b, settingsMode) - getSortKey(a, settingsMode));

    const top5Itm = itmRows.slice(0, 5);
    if (top5Itm.length === 0) return null;

    const strikes = top5Itm.map((r: any) => r.strike);
    const minStrike = Math.min(...strikes);
    const maxStrike = Math.max(...strikes);
    const buffer = gap / 4;

    let status = 'Sideways';
    if (atmStrike === minStrike) status = 'BULL';
    else if (atmStrike === maxStrike) status = 'BEAR';

    if (status === 'Sideways') return null;

    // Entry logic
    let entryStrike = atmStrike;

    let entryPrice = 0;
    
    const liveRawOptsArr = context.chain || marketData.options || marketData.optionChain || [];
    const liveFlatOpts = ensureFlatOpts(liveRawOptsArr);

    const optionType = status === 'BULL' ? 'CE' : 'PE';
    const atmRow = liveFlatOpts.find((r: any) => r.strike === entryStrike && r.type === optionType);

    if (atmRow) {
        entryPrice = atmRow.ltp || atmRow.close || atmRow.price || 0;

        if (entryPrice > 0) {
            return {
                trade_type: status as any,
                strike: entryStrike,
                option_type: status === 'BULL' ? 'CE' : 'PE',
                entry_price: entryPrice,
                remarks: `Touched ${status === 'BULL' ? 'MIN' : 'MAX'} ITM (${status === 'BULL' ? minStrike : maxStrike})`
            };
        }
    }

    return null;
};
